import { z } from 'zod/v4'
import { PlatformType } from '@/utils/convert-platform'

export const platformTypeSchema = z.enum(PlatformType)
